import api from "./api";

export async function fetchBlogList(params = {}) {
  const response = await api.get("/blogs/get-all-blogs", { params });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchBlogFilters(params = {}) {
  const response = await api.get("/blogs/filter-list", { params });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchBlogDetail(params = {}) {
  const response = await api.get("/blogs/get-blog-detail", { params });
  return response?.data?.dataset?.data || {};
}

export async function fetchBlogComments(params = {}) {
  const response = await api.get("/blogs/get-blog-comments", { params });
  return response?.data?.dataset?.data || {};
}

async function postBlogAction(endpoint, payload) {
  const response = await api.post(endpoint, payload);
  return response?.data?.dataset?.data || {};
}

export const toggleBlogLike = (payload) => postBlogAction("/blogs/post-like", payload);
export const toggleBlogBookmark = (payload) => postBlogAction("/blogs/post-bookmark", payload);
export const toggleBlogReadStatus = (payload) => postBlogAction("/blogs/mark-read", payload);
export const createBlogComment = (payload) => postBlogAction("/blogs/create-blog-comment", payload);
export const toggleBlogCommentLike = (payload) => postBlogAction("/blogs/post-comment-like", payload);
export const storeBlogReadingTime = (payload) => postBlogAction("/blogs/store-time", payload);
